module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_007.png?b7f1d395b494affe659529148a8cf421";